export const CSV_DOWNLOAD_LABEL = 'Download Reports'
export const DOWNLOAD_LINK_TEXT = 'Export'
